import { RefreshCcw, Smartphone, CloudUpload } from 'lucide-react';
import { useAppleHealth } from '../../hooks/useAppleHealth';
import styles from './AppleHealthCard.module.css';

export function AppleHealthCard() {
  const { 
    isAvailable, 
    isAuthorized, 
    healthData, 
    loading, 
    isSyncingToCloud,
    requestPermission, 
    refresh 
  } = useAppleHealth();

  // 如果不支持 HealthKit (如 Web 端 / Android端)，优雅降级不渲染卡片
  if (!loading && !isAvailable) {
    return null;
  }

  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <div className={styles.title}>
          <Smartphone size={18} />
          <span>Apple Health</span>
        </div>
        <div className={`${styles.status} ${isAuthorized ? styles.statusActive : ''}`}>
          {isAuthorized ? '已连接' : '未连接'}
        </div>
      </div>

      <div className={styles.content}>
        {!isAuthorized ? (
          <>
            <p className={styles.description}>
              连接 Apple Health 后，仅同步你授权的步数、心率、体重、睡眠、活动日汇总和单次运动摘要，用于补充健康档案。
            </p>
            <button 
              className={styles.connectButton}
              onClick={requestPermission}
              disabled={loading}
            >
              {loading ? '连接中...' : '授权连接'}
            </button>
          </>
        ) : (
          <>
            {healthData.length > 0 ? (
              <div className={styles.metricsGrid}>
                {/* 仅取前 4 个维度展示摘要 */}
                {healthData.slice(0, 4).map((metric) => (
                  <div key={metric.key} className={styles.metricItem}>
                    <div className={styles.metricLabel}>{metric.label}</div>
                    <div className={styles.metricValueFrame}>
                      <span className={styles.metricValue}>{metric.value}</span>
                      <span className={styles.metricUnit}>{metric.unit}</span>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className={styles.emptyState}>
                暂无最新数据
              </div>
            )}
            
            <div className={styles.footer}>
              <span className={styles.footerText} style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                {isSyncingToCloud && <CloudUpload size={14} className="animate-pulse" />}
                <span>仅同步已授权的步数、心率、体重、睡眠、活动日汇总和单次运动摘要</span>
              </span>
              <button 
                className={styles.refreshButton}
                onClick={refresh}
                disabled={loading}
              >
                <RefreshCcw size={14} className={loading ? 'animate-spin' : ''} />
                <span>同步</span>
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
